import { ThemeOptions } from '@mui/material';

// Use the theme.spacing() helper to create consistent spacing between the elements of your UI.
// Material UI uses a recommended 8px scaling factor by default.

export const spacing: ThemeOptions['spacing'] = 8;
